import { RecaptchaActions } from '../../rest/consumer';

export const handleReCaptcha = (
  onSuccess?: Function,
  onError?: (error: any) => void,
  action?: RecaptchaActions,
): void => {
  (window as any).grecaptcha?.enterprise?.ready(() => {
    (window as any).grecaptcha.enterprise.execute(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY,
      { action })
      .then((recaptchaToken: string) => onSuccess?.(recaptchaToken))
      .catch((error: any) => {
        onError?.(error);
      });
  });
};
